// extracted by mini-css-extract-plugin
export default {"container":"container--wy84V","popoverContent":"popoverContent--_qMfY","hidden":"hidden--U1ekW","linkContainer":"linkContainer--XPjk_","link":"link--_SE8X","footer":"footer--_d368"};